const product_info_container = document.querySelector('.product__info-container')
let result = JSON.parse(product_info_container.getAttribute('data-params')) ? JSON.parse(product_info_container.getAttribute('data-params')) : "";
const custom_info = document.querySelector('.product__info-container .custom_info')
if (result) {
    let tempDom = ``;
    Object.keys(result).forEach(item => {
        const params = result[item].settings;
        if (item === 'modules') {
            let modulesDom = ``
            params.forEach(item => {
                modulesDom += `
           <div class="modules-item">
               <img src="${item.image}">
               <span>${item.name}</span>
           </div>
         `
            })
            tempDom += `
                    <div class="expend_bar">
                       <div class="custom_title">
                        <span>${result[item].title}</span>
                        <div>
                          <svg class="icon plus" xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                            <path d="M5.88912 1.13037V12.0395M0.43457 6.58492H11.3437" stroke="black" stroke-width="0.5" stroke-linecap="square"/>
                          </svg>
                          <svg class="icon discount" xmlns="http://www.w3.org/2000/svg" width="12" height="1" viewBox="0 0 12 1" fill="none">
                            <path d="M0.43457 0.584961H11.3437" stroke="#F9FAF6" stroke-width="0.5" stroke-linecap="square"/>
                          </svg>
                        </div>
                        </div>
                           <div class="main_container ${item}">
                                ${modulesDom}
                           </div>
                     </div>
             `
        }
        if (item === 'dimensions') {
            let dimensionsDom = ``
            params.forEach(item => {
                let paramsDom = ''
                const arr = Object.entries(item.params)
                arr.forEach(item => {
                    paramsDom += `${item[0]} ${item[1]}  `
                })
                dimensionsDom += `
           <div class="dimensions-item">
               <span>${item.name}:</span>
               <span>${paramsDom}</span>
           </div>
         `
            })
            tempDom += `
                    <div class="expend_bar">
                       <div class="custom_title">
                        <span>${result[item].title}</span>
                        <div>
                          <svg class="icon plus" xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                            <path d="M5.88912 1.13037V12.0395M0.43457 6.58492H11.3437" stroke="black" stroke-width="0.5" stroke-linecap="square"/>
                          </svg>
                          <svg class="icon discount" xmlns="http://www.w3.org/2000/svg" width="12" height="1" viewBox="0 0 12 1" fill="none">
                            <path d="M0.43457 0.584961H11.3437" stroke="#F9FAF6" stroke-width="0.5" stroke-linecap="square"/>
                          </svg>
                        </div>
                        </div>
                           <div class="main_container ${item}">
                                ${dimensionsDom}
                           </div>
                     </div>
             `
        }
        if (item === 'materials & finish' || item ==='descrition') {
            let materialDom = ``
            params.forEach(item => {
                let paramsDom = ``
                const arr = Object.entries(item.params)
                arr.forEach(item => {
                    paramsDom += `<p class="params">${item[0]}: ${item[1]}</p>`
                })
                materialDom += `
           <div class="material-item">
               <div>${item.name}:</div>
               ${paramsDom}
           </div>
         `
            })
            tempDom += `
                    <div class="expend_bar">
                       <div class="custom_title">
                        <span>${result[item].title}</span>
                        <div>
                          <svg class="icon plus" xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                            <path d="M5.88912 1.13037V12.0395M0.43457 6.58492H11.3437" stroke="black" stroke-width="0.5" stroke-linecap="square"/>
                          </svg>
                          <svg class="icon discount" xmlns="http://www.w3.org/2000/svg" width="12" height="1" viewBox="0 0 12 1" fill="none">
                            <path d="M0.43457 0.584961H11.3437" stroke="#F9FAF6" stroke-width="0.5" stroke-linecap="square"/>
                          </svg>
                        </div>
                        </div>
                           <div class="main_container material">
                                ${materialDom}
                           </div>
                     </div>
             `
        }
    })
    custom_info.innerHTML = tempDom
}
const expend_bars = document.querySelectorAll('.product__info-container .custom_info .expend_bar')
expend_bars.forEach(item => {

    item.addEventListener('click', () => {
        if (item.classList.contains('active')){
            item.classList.remove('active')
        }else{
            expend_bars.forEach(sub => {
            sub.classList.remove('active')
          })
        item.classList.toggle('active')
        }
       
    })
})
